import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { bulkSparesTableColumnsConfig } from "./bulkSparesTableColumnDef";

import { Table } from "../../../../component/table/Table";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";
import { selectBulkSparesFilterState } from "../../../../store/bulk/bulkSparesFilterSlice";
import {
  selectBulkSpares,
  useGetBulkSpareListQuery,
} from "../../../../services/bulk/spares/bulkSparesApiSlice";

export const BulkSparesTablePage = () => {
  const navigate = useNavigate();

  /* ✅ Get filters from redux */
  const { seller_id, status } = useSelector(selectBulkSparesFilterState);

  /* ✅ Call RTK Query with filters */
  const { isLoading, isError, isSuccess } = useGetBulkSpareListQuery({
    seller_id,
    status,
  });

  /* ✅ Get normalized data from entity adapter */
  const bulkSpareList = useSelector(selectBulkSpares);

  const handleNavigate = useCallback(
    (request_id) => {
      navigate(`/bulk_deals/spares/${request_id}`);
    },
    [navigate],
  );

  const handleDownload = useCallback(() => {
    // handle download logic here
  }, []);

  const columnDefs = useMemo(
    () => bulkSparesTableColumnsConfig(handleDownload, handleNavigate),
    [handleDownload, handleNavigate],
  );

  if (isError) return <div>Something went wrong</div>;

  return isSuccess ? (
    <Table data={bulkSpareList} columns={columnDefs} loading={isLoading} />
  ) : (
    <CategoryPageSkeleton />
  );
};
